import { Component } from '@angular/core';

@Component({
  selector: 'app-nutriscore-modal-en',
  templateUrl: './nutriscore-modal-en.component.html',
  styleUrls: ['./nutriscore-modal-en.component.scss'],
  standalone: false,
})
export class NutriscoreModalEnComponent {}
